export default __webpack_public_path__ + "static/media/header.200bace0.png";